<template>
    <div class="py-5 mt-5" id="clientHeader">
        <template v-if="!$route.path.includes('coupon')">
            <!-- MD et +  -->
            <v-layout class="hidden-sm-and-down justify-space-between" row wrap>
                <v-flex pl-4 sm6>
                    <h1 tabindex="0" class="mb-2 mr-4 display-1" id="establishmentName">
                        {{ getEstablishment.name }}
                        <v-chip v-if="isGapModeOn" class="white--text red">
                            {{ $t('base.gapMode') }}
                        </v-chip>
                    </h1>
                </v-flex>
                <v-flex pr-4 sm4>
                    <v-img :src="getClientLogo" contain max-height="70px" max-width="480px" />
                </v-flex>
            </v-layout>
            <!-- SM et -  -->
            <v-layout class="hidden-md-and-up" row wrap>
                <v-flex v-if="getClientLogo" px-4 xs12>
                    <v-img :src="getClientLogo" class="mx-auto" max-width="360px" />
                </v-flex>
                <v-flex my-6 px-4 xs12>
                    <h1 tabindex="0" class="title text-center" id="establishmentNameMobile">
                        {{ getEstablishment.name }}
                        <v-chip v-if="isGapModeOn" class="white--text red">
                            {{ $t('base.gapMode') }}
                        </v-chip>
                    </h1>
                </v-flex>
            </v-layout>
        </template>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { EstablishmentSetting } from '@/enums';

export default {
    name: 'establishment-header',
    components: {},
    computed: {
        ...mapGetters({
            getEstablishment: 'establishment/getEstablishment',
            getEstablishmentSettingById: 'establishment/getEstablishmentSettingById',
            isGapModeOn: 'gap/isGapModeOn',
        }),
        getClientLogo() {
            return this.getEstablishmentSettingById(EstablishmentSetting['USE_CLIENT_LOGO'])
                ? this.getEstablishmentSettingById(EstablishmentSetting['CLIENT_LOGO']) : '';
        },
    },
    mounted() {
        const skipTo = document.querySelector('#skip-to .vue-skip-to__link');
        if(skipTo) {
            skipTo.addEventListener('click', this.onSkipToClick);
        }
    },
    methods: {
        onSkipToClick() {
            const element = document.getElementById(this.$vuetify.breakpoint.smAndDown ? 'establishmentNameMobile' : 'establishmentName');
            element.focus();
        },
    },

};
</script>

<style lang="scss">
@import './src/assets/scss/variables';
</style>
